import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38aae08d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aae08d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38aae08d')) {
      api.createRecord('38aae08d', component.options)
    } else {
      api.reload('38aae08d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38aae08d&scoped=true", function () {
      api.rerender('38aae08d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/exchange/index.vue"
export default component.exports